import React, { useState } from 'react'
import { Index, ValidationIssue } from 'api'
import { ModalWindow, ModalFooter } from 'view/components/panels'
import { Tabs } from 'view/components/tabs'
import { DialogRow, DialogField } from 'view/components/inputs'
import { TextButton, TextButtonType } from 'view/components/buttons'
import { IndexOverviewPanel } from './IndexOverviewPanel'
import { Locale, Translation } from 'locale'
import { Content } from './IndexDialog.styles'

export interface IndexDialogComponentProps {
  title: string
  validationIssues: ValidationIssue[]
  readOnly: boolean

  onClose?: () => void
  onSave: () => void
  index: Index
  onUpdate: (partialIndex: Partial<Index>) => void
}

export const IndexDialogComponent: React.FC<IndexDialogComponentProps> = ({
  index,
  readOnly,
  title,
  validationIssues,
  onClose,
  onSave,
  onUpdate
}) => {
  const [selectedTab, setSelectedTab] = useState(Translation.TC_OVERVIEW)
  const hasValidationIssues = !!validationIssues && validationIssues.length > 0

  const onChangeTab = (tab: Translation) => setSelectedTab(tab)

  return (
    <ModalWindow title={title}>
      <Tabs dataTestId={'IndexDialog'} selectedTab={selectedTab} tabs={[Translation.TC_OVERVIEW]} onChangeTab={onChangeTab} />
      <Content>
        {selectedTab === Translation.TC_OVERVIEW && (
          <IndexOverviewPanel index={index} readOnly={readOnly} validationIssues={validationIssues} onUpdate={onUpdate} />
        )}
      </Content>
      <ModalFooter>
        <DialogRow>
          <DialogField>
            <TextButton dataTestId={'IndexDialog-TextButton-CancelButton'} type={TextButtonType.Tertiary} onClick={onClose}>
              {Locale.translate(Translation.TC_BUTTON_CANCEL)}
            </TextButton>
          </DialogField>
          <DialogField flex={0}>
            <TextButton
              dataTestId={'IndexDialog-TextButton-SaveButton'}
              type={TextButtonType.Primary}
              disabled={readOnly || hasValidationIssues}
              onClick={onSave}>
              {Locale.translate(Translation.TC_BUTTON_SAVE)}
            </TextButton>
          </DialogField>
        </DialogRow>
      </ModalFooter>
    </ModalWindow>
  )
}
